import React from "react";
import { useNavigate } from "react-router-dom";
import "./Closed.css";

import logo, { logoOnDark } from "../assets/logo.js";
import { useHomeVideo } from "../config/HomeVideos";
import { useNavDirection } from "../NavDirectionContext";

export default function Contact() {
  const navigate = useNavigate();
  const { setDir } = useNavDirection();

  // Même vidéo et même logique de couleur que la home. Depuis le 20/09/2026
  // cette page ne charge plus background.mp4 (11 Mo) : elle partage la vidéo
  // déjà tirée au sort pour l'accueil, donc déjà en cache, et sans piste audio.
  const { darkText } = useHomeVideo();

  const goHome = () => {
    setDir("down");
    navigate("/");
  };

  // ✅ URLs canoniques (profils) — pas de jetons de partage qui expirent.
  const links = {
    instagram: "https://www.instagram.com/ghettosymphonystore/",
    tiktok: "https://www.tiktok.com/@ghettosymphonystore",
    pinterest: "https://fr.pinterest.com/ghttsymphony/",
  };

  return (
    <div
      className={`closedPlain closedPlain--onVideo closedPlain--videoFull${
        darkText ? " closedPlain--darkText" : ""
      }`}
    >

      <div className="closedPlain__center">
        <button
          type="button"
          className="closedVideo__logoBtn"
          onClick={goHome}
          aria-label="Back to home"
        >
          <img
            className="closedVideo__logo"
            src={darkText ? logo : logoOnDark}
            alt="Ghetto Symphony"
          />
        </button>

        <div className="contactIcons" aria-label="Social links">
          <a
            className="contactIcon"
            href={links.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <svg
              className="contactIcon__img"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <rect
                x="2"
                y="2"
                width="20"
                height="20"
                rx="5"
                ry="5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle
                cx="12"
                cy="12"
                r="4.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle cx="17.5" cy="6.5" r="1.4" fill="currentColor" />
            </svg>
          </a>

          <a
            className="contactIcon"
            href={links.tiktok}
            target="_blank"
            rel="noreferrer"
            aria-label="TikTok"
          >
            <svg
              className="contactIcon__img"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M16.5 3c.3 2.1 1.6 3.7 3.5 4v3c-1.4 0-2.7-.4-3.8-1.1v6.2c0 3.2-2.6 5.9-5.9 5.9S4.4 18.3 4.4 15.1s2.6-5.9 5.9-5.9c.4 0 .8 0 1.2.1v3.1c-.4-.1-.8-.2-1.2-.2-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9V3h3.4z"
              />
            </svg>
          </a>

          <a
            className="contactIcon"
            href={links.pinterest}
            target="_blank"
            rel="noreferrer"
            aria-label="Pinterest"
          >
            <svg
              className="contactIcon__img"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M12 2C6.5 2 2 6.5 2 12c0 4.1 2.5 7.6 6 9.1-.1-.8-.2-2 0-2.8.2-.8 1.2-5 1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.9 0 1.3.6 1.3 1.4 0 .9-.5 2.1-.8 3.3-.2.9.5 1.7 1.4 1.7 1.7 0 2.9-2.2 2.9-4.8 0-2-1.3-3.5-3.8-3.5-2.7 0-4.4 2-4.4 4.3 0 .8.2 1.4.6 1.8.2.2.2.3.1.5l-.2.8c-.1.3-.3.4-.5.2-1.1-.5-1.7-1.8-1.7-3.3 0-2.5 2.1-5.5 6.3-5.5 3.4 0 5.6 2.4 5.6 5 0 3.4-1.9 6-4.7 6-1 0-1.9-.5-2.2-1.1l-.6 2.3c-.2.8-.7 1.6-1 2.2.7.2 1.5.3 2.3.3 5.5 0 10-4.5 10-10S17.5 2 12 2z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
